import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "tw-flex tw-items-center" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = { class: "content" }

import { PropType } from 'vue'; 
    
    import { BadgeProperties } from 'src/types/status';
    
    
export default /*@__PURE__*/_defineComponent({
  __name: 'StatusBadge',
  props: {
        model: {
            type: Object as PropType<BadgeProperties>,
            required: true
        },
        shortLabel: {
            type: Boolean,
            default: false
        },
        textSize: {
            type: String,
            default: 'tw-text-xs'
        },
        textColour: {
            type: String,
            default: 'tw-text-slate-500'
        },
        fontWeight: {
            type: String,
            default: 'tw-font-medium'
        }
    },
  setup(__props) {

    const props = __props

return (_ctx: any,_cache: any) => {
  const _component_q_spinner = _resolveComponent("q-spinner")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (__props.model.loader)
        ? (_openBlock(), _createBlock(_component_q_spinner, {
            key: 0,
            size: "10px",
            class: _normalizeClass(__props.model.textColour)
          }, null, 8, ["class"]))
        : (_openBlock(), _createElementBlock("div", {
            key: 1,
            class: _normalizeClass(["tw-p-1 tw-rounded-full", __props.model.bgColour])
          }, null, 2))
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", {
        class: _normalizeClass(["tw-pl-1 ellipsis", __props.textSize, __props.textColour, __props.fontWeight])
      }, _toDisplayString(__props.shortLabel ? (__props.model.shortLabel ?? __props.model.label) : __props.model.label), 3)
    ])
  ]))
}
}

})